export default __webpack_public_path__ + "static/media/ThemeScreen.ec04bb5a.svg";